import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { SiteDataProvider } from "@/context/SiteDataContext";
import MaintenanceGate from "@/components/feature/MaintenanceGate";

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <SiteDataProvider>
        <MaintenanceGate>
          <AppRoutes />
        </MaintenanceGate>
      </SiteDataProvider>
    </BrowserRouter>
  );
}

export default App;
